var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfileFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.372 6.017a2.99 2.99 0 0 1 2.985 2.985 2.99 2.99 0 0 1-2.985 2.985 2.99 2.99 0 0 1-2.985-2.985 2.99 2.99 0 0 1 2.985-2.985Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.461 22.346A11.995 11.995 0 0 0 24.378 12c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12 0 4.402 2.37 8.25 5.904 10.338v-7.287h12.18v7.295Zm-6.09-17.882a4.535 4.535 0 0 0-4.537 4.538 4.535 4.535 0 0 0 4.538 4.537 4.535 4.535 0 0 0 4.537-4.537 4.535 4.535 0 0 0-4.537-4.538Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.91 23.115v-6.511H7.833v6.506c1.402.574 2.936.89 4.544.89 1.604 0 3.133-.314 4.531-.885Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfileFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ProfileFilled.3b8b84089942c0beb45cac31635406af.svg";